.wrapper {
  background-color: transparent;
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  width: fit-content;

  // Default indicator color
  .indicator {
    color: var(--background-color);
  }

  &:not(.disabledBase) .root {
    background-color: var(--secondary-background-color);
    border-color: var(--input-border-color);

    &[data-state="checked"] {
      border-color: var(--primary-color);
      background-color: var(--primary-color);
    }

    &[data-state="indeterminate"] {
      .indicator {
        color: var(--primary-color);
      }
    }

    &:disabled {
      cursor: not-allowed;
    }
  }

  // Hover states
  &:hover:not(.disabledBase) {
    .root {
      border-color: var(--primary-color);
    }
  }

  // Disabled and locked states
  &.disabled,
  &.locked {
    .root {
      border-color: var(--input-border-color);
      background-color: var(--secondary-background-color);
      cursor: not-allowed;

      &:hover {
        border-color: var(--input-border-color) !important;
        background-color: var(--secondary-background-color) !important;
      }
    }

    .label {
      cursor: not-allowed;
    }
  }

  &.disabled {
    opacity: 0.5;

    .indicator {
      color: var(--secondary-text-color);
    }
  }

  // ReadOnly states
  &.readOnly {
    .root {
      cursor: default;
      background-color: var(--secondary-background-color);
      border-color: transparent;
    }

    .indicator {
      color: var(--text-color);
    }

    .label {
      cursor: default;
    }
  }
}

.root {
  transition: all 200ms ease-in;
  border-radius: 4px;
  cursor: pointer;
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-shrink: 0;
  border: 1px solid transparent;
  background-color: transparent;
}

.indicator {
  display: flex;
  align-items: center;
  justify-content: center;
}

.lockIcon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  width: 10px;
  height: 10px;
}
